import { getLocaleMessages } from '@/locales/messages';
import { translateShellText } from '@/locales/shellText';
import type { AppLocale } from '@/stores/localeStore';
import { findRoute } from './routes';
import type { AppMenuItem } from './types';

export function localizeMenuItemName(item: AppMenuItem, locale: AppLocale) {
  if (item.locale) {
    return getLocaleMessages(locale)[item.locale] ?? item.nameEn ?? item.name;
  }

  return translateShellText(locale, item.name, item.nameEn ?? item.name);
}

export function localizeMenuItems(
  items: AppMenuItem[],
  locale: AppLocale,
): AppMenuItem[] {
  return items.map((item) => ({
    ...item,
    name: localizeMenuItemName(item, locale),
    children: item.children ? localizeMenuItems(item.children, locale) : undefined,
  }));
}

export function routeLabel(path: string, fallback: string, locale: AppLocale) {
  const route = findRoute(path.split(/[?#]/)[0]);
  if (route?.locale) {
    return getLocaleMessages(locale)[route.locale] ?? route.labelEn ?? route.label;
  }

  return translateShellText(
    locale,
    route?.label ?? fallback,
    route?.labelEn ?? fallback,
  );
}
